<script setup lang="ts">
import ChatHeader from "~/components/Chat/ChatHeader.vue";
import useVideoChat from "~/composables/useVideoChat";
import { useAuthStore } from "~/stores/auth/store";

const props = defineProps({
  videoId: {
    type: String,
    required: true,
  },
});

const authStore = useAuthStore();
const { user } = storeToRefs(authStore);

const { initChat, connection, readyState } = useVideoChat({
  videoId: props.videoId,
});

const currentStep = ref<"username-step" | "chat-step">(
  user.value.username ? "chat-step" : "username-step",
);
</script>

<template>
  <div
    class="flex h-[576px] w-full flex-col justify-between overflow-y-hidden border border-surface-border md:w-96"
  >
    <ChatHeader />
    <ChatUserNameStep
      v-if="currentStep === 'username-step'"
      v-model:current-step="currentStep"
      class="flex-grow"
    />
    <template v-if="currentStep === 'chat-step'">
      <ChatPanel :video-id="videoId" />
      <ChatFooter
        :init-chat="initChat"
        :connection="connection"
        :ready-state="readyState"
      />
    </template>
  </div>
</template>

<style scoped></style>
